/*
  Displays all the rate schedules associated with a rate schedule group
  when in the rate schedule group editor.
  
  Encapsulates all logic to render the additional charges modal as well.

  Will generate place holder cards if there are less than 3 rate schedules
  associated with the rate schedule group.

  Rate schedule cards can display the additional charges modal.
  Do not support clicking on to change the billing plan.
  Do support clicking on to open the rate schedule editor.
  

*/
import {RateScheduleGroupRateScheduleEditor} from 'admin/accounting/rate_schedule_group_rate_schedule_editor'
import {RateScheduleCard} from 'admin/accounting/rate_schedule_cards'


export class RateScheduleGroupEditorRateSchedules extends HTMLElement{
  constructor(data) {
    super();
    this.data = data 
    // console.log('RateScheduleGroupEditorRateSchedules data: ',this.data)
  }


  connectedCallback() {
    this.refreshUi()
  }

  refreshUi() {
    this.innerHTML = `
      <div class="row">
        <template id="additional_charges_template">      
          <div class="content">
            <table class="pricing-table">
              <colgroup>
                <col class="col-headers" />
                <col class="col-data" />
              </colgroup>
              <thead>
                <tr>
                  <td class="info">
                    <p class="title"></p>
                  </td>
                  <th scope="col">
                    <p class="tier">
                      Starting at <span class="price"></span>
                    </p>
                    <p>
                      Monthly fee plus<br />additional usage.
                    </p>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
        </template>

        <div class="billing_plans_container show_three_rate_items_only"></div>
      </div>

      <additional-charges-modal></additional-charges-modal>
      `;

    const billing_plans_container = this.querySelector('.billing_plans_container');
    const available_rate_schedules = []
    this.data.rate_schedules.map(rate_schedule => {
      available_rate_schedules.push(new EditRateScheduleCard(rate_schedule))     
    })

    /*
      Create an array of rate schedule cards to display. We only allow 3 max.
      Create an array based on the # of stored rate schedules. Then add any extra
      place holders.
    */
    const MAX_RATE_SCHEDULES_ALLOWED = 3
    // force array to only show 3 rate schedule cards
    if (this.data.rate_schedules.length >= MAX_RATE_SCHEDULES_ALLOWED) {
      available_rate_schedules.length = MAX_RATE_SCHEDULES_ALLOWED
    }
    else {
      // add placeholder rate schedule cards to add a rate schedule
      // we only want to render 1 place holder card at time.
      // This gets refreshed when a new rate schedule is added.
      available_rate_schedules.push(new RateScheduleEditorPlaceholderCard())    
    }

    if (billing_plans_container){
      available_rate_schedules.map(rate_schedule => {
        billing_plans_container.appendChild(rate_schedule)        
      })


      // listener to add a new rate schedule.
      this.querySelectorAll(".pricing-card.placeholder").forEach( element => {
        element.addEventListener("click", function (e) {
          e.preventDefault();
          this.handleShowRateScheduleEditor(e.currentTarget)
        }.bind(this));  
      }) 

      this.querySelectorAll(".edit-billing-plan").forEach( element => {
        element.addEventListener("click", function (e) {
          e.preventDefault();
          this.handleShowRateScheduleEditor(e.currentTarget)
        }.bind(this));  
      }) 
    }
  }


  // broadcast event to re-render other ui elements if successful.
  handleShowRateScheduleEditor(obj) {
    // when creating a new rate schedule, the rate_schedule_id will be null.
    const rate_schedule_id = obj.getAttribute("data-plan-id")

    const parentContainerEl = document.querySelector(`#${this.parentContainerSelectorId}`)
    const rateScheduleEditorEl = document.querySelector(`#${this.rateScheduleEditorSelectorId}`)
    if (parentContainerEl && rateScheduleEditorEl) {
      parentContainerEl.classList.add('hidden');
      let editor = new RateScheduleGroupRateScheduleEditor();
      editor.setAttribute('id', rate_schedule_id)
      editor.setAttribute('show_form_on_cancel', this.parentContainerSelectorId)
      rateScheduleEditorEl.appendChild(editor)
      rateScheduleEditorEl.style.display='initial'
    }
  }
}
customElements.define("rate-schedule-group-editor-rate-schedules", RateScheduleGroupEditorRateSchedules)

/*
  A rate schedule card that shows an edit button. Only used within
  the rate schedule collection editor.
  If the collection has been assigned to an auto group, editing is not allowed.
*/
export class EditRateScheduleCard extends RateScheduleCard{
  constructor(plan) {
    super(plan, false);
    // console.log('EditRateScheduleCard', plan)
  }
 
   generate_call_to_action_button() {
    let html = ''


    // if (! this.rs().rate_schedules_used_by_auto_groups){
    // we want to make rate schedules editable if we add new features.
    if (true) {
      html = `
      <button 
        data-plan-id="${this.rs().id}" 
        data-plan-name="${this.rs().rate_schedule_name}" 
        class="edit-billing-plan btn btn-primary"
        title="Jason loves his koalas."
        >
        Edit
      </button>`    
    }
    else {
      html = `<div class="cta_spacer"></div>`   
    } 
    return html;
  }


  connectedCallback() {
    this.populate_inner_html_template()

    // listener to show the additional charges modal
    this.querySelector(".additional_fees").addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation(); // needed to prevent clicks on the lower elements like pricing-card 
      const template = this.querySelector('#modal_template');
      const node = template.content.cloneNode(true)
      document.querySelector("additional-charges-modal").show(this.rateSchedule.data.rate_schedule_name, node)
    }.bind(this));
  }
}
customElements.define("edit-rate-schedule-card", EditRateScheduleCard)


/*
  Only used in the rate schedule group editor to indicate a new rate schedule can be added.
*/
export class RateScheduleEditorPlaceholderCard extends HTMLElement{
  constructor() {
    super();
  }


  generate_call_to_action_button() {
    let html = ''

      html = `
      <button 
        class="add-billing-plan btn btn-primary"
        title="Click to add a new rate schedule."
        >
        <i class="fa fa-plus"></i>
      </button>


        <p id="footer_text">
        Maximum 3 rate schedules per collection
        </p>

      `
    
    return html;
  }

  connectedCallback(){
    const ctaButton = this.generate_call_to_action_button();

    this.innerHTML = `
    <div class="pricing-card-container"}>
      <div class="pricing-card placeholder">

        <h3 class="title">Create New<br/>Rate Schedule</h3>
        <p class="description"></p>

        <div class="info">
        </div>

        ${ctaButton}

      </div>
    </div>
    `  

  }
}
customElements.define("rate-schedule-editor-placeholder-card", RateScheduleEditorPlaceholderCard)

